import Spinner from 'src/javascripts/components/utilities/Spinner'

export default class ExportsEdit {

  constructor() {}

  render() {

    // Reload page when template changes
    $('#template_id').bind("typeahead:select typeahead:autocomplete", function (ev, suggestion) {
      $(this).typeahead('val', '');
      $('.modal-body').css('opacity', '0.3');
      Spinner('.modal-content');
      const templateId = suggestion.record_id;
      const url = new URL(window.location.href);
      url.searchParams.set('template_id', templateId);
      Turbo.visit(url.toString());
    });

  }

}
